import React from 'react';
//import FortisButton from '../../Basic/FortisButton';
import { L, google } from '../../../lib/google';
import SectionHeader from '../../Basic/SectionHeader';
import * as consts from '../../../constants';
import { serviceLocationChanged } from '../../../actions';
const overlayUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:51690/api/googleMap/getoverlay' : '/api/googleMap/getoverlay';
const mapConfig = {
    lat: 54.41892996865827,
    lng: -124.62890625,
    zoom: 5,
    minZoom: 5,
    maxZoom: 21,
    scrollWheelZoom: false,
    touchZoom: false,
    roadLayer: new L.Google('ROADMAP'),
    satLayer: new L.Google('SATELLITE'),
    country: { 'country': 'ca' },
    overlayLayer: new L.tileLayer.wms(overlayUrl,
        {
            layers: 'default_b_defaultfg,default_b_defaultbg',
            format: 'image/png',
            transparent: true,
            version: '1.1.1',
            minZoom: 5,
            maxZoom: 21,
            crs: L.CRS.EPSG3857,
            styles: '',
            tileSize: 256,
            opacity: 1.0
        }),
    bounds: {
        //types: ['address']
        bounds: new google.maps.LatLngBounds(
            new google.maps.LatLng(48.998207, -139.059593),
            new google.maps.LatLng(60.002437, -114.055918)
        )
    }
};
let autocomplete, map, marker, input;

class GoogleMap extends React.Component {
    constructor() {
        super();
        this.state = {
            baseLayers: {
                'Google Streets': mapConfig.roadLayer,
                'Google Satellite': mapConfig.satLayer
            },
            overlay: { 'GSA WMS': mapConfig.overlayLayer },
            customAddress: ''
        };
    }


    componentDidMount() {
        this.initMap();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.customAddress && this.state.customAddress != nextProps.customAddress) {
            this.plotPlaceOnMap(nextProps.customAddress.place, false);
            document.getElementById('search-input').value = nextProps.customAddress.address;
            this.setState({ customAddress: nextProps.customAddress });
        }

    }

    getNameInGIS = () => {
        switch (this.props.productName) {
            case consts.SERVICE_REMOVAL_NAME:
                return consts.SERVICE_REMOVAL_NAME_GIS;
            case consts.NEW_GAS_LINE_NAME:
                return consts.NEW_GAS_LINE_NAME_GIS;
        }
    }
    onSearchClick = () => {
        let place = autocomplete.getPlace();
        console.log(place);
        this.plotPlaceOnMap(place);
    }

    plotPlaceOnMap = (place, isParcelRefreshNeeded = true) => {

        if (!place) {
            return;
        }

        let lat, lng;
        if (typeof place.geometry.location.lat === 'function') {
            lat = place.geometry.location.lat();
            lng = place.geometry.location.lng();
        }
        else {
            lat = place.geometry.location.lat;
            lng = place.geometry.location.lng;
        }

        map.setZoom(19);
        map.setView([lat, lng], 19); // zoom level 19 is where the property layer is visible

        if (!isParcelRefreshNeeded) setTimeout(() => { }, 625);//just to make sure map is fully loaded in case of project resume

        // if (marker)
        //     map.removeLayer(marker);
        if (!marker) {
            marker = new L.Marker([lat, lng], { draggable: true });
            map.addLayer(marker);
        }
        marker.on('dragend', (e) => this.getParcel(e.target));
        if (isParcelRefreshNeeded)
            this.getParcel(marker);
    }

    placeIsInBC = (place) => {
        if (place.address_components) {
            for (let i = 0; i < place.address_components.length; i++) {
                if (place.address_components[i].types[0] === 'administrative_area_level_1') {
                    if (place.address_components[i].long_name === 'British Columbia') {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    getParcel = (marker) => {
        let coords = marker.getLatLng();

        let model = {
            Latitude: coords.lat,
            Longitude: coords.lng,
            ServiceType: this.getNameInGIS()
        };
        this.props.dispatch(serviceLocationChanged(this.props.productName));
        this.props.dispatch({ type: 'GET_PARCEL', model });
        marker.bindPopup(window.osa.lookup.serviceAddress.markerText, { closeButton: true, closeOnClick: false }).openPopup();
    }

    initMap = () => {
        map = new L.Map('map',
            {
                minZoom: mapConfig.minZoom,
                maxZoom: mapConfig.maxZoom,
                scrollWheelZoom: mapConfig.scrollWheelZoom,
                touchZoom: mapConfig.touchZoom,
                attributionControl: false
            });
        map.setView([mapConfig.lat, mapConfig.lng], mapConfig.zoom);
        map.addLayer(mapConfig.roadLayer);
        map.addLayer(mapConfig.overlayLayer);

        L.control.layers(this.state.baseLayers, this.state.overlay).addTo(map);

        input = (document.getElementById('search-input'));
        autocomplete = new google.maps.places.Autocomplete(input, {
            componentRestrictions: mapConfig.country,
            types: ['geocode']
        });
        //  autocomplete.setComponentRestrictions(mapConfig.country);

        autocomplete.addListener('place_changed', () => {
            let place = autocomplete.getPlace();
            this.plotPlaceOnMap(place);
        });
    }

    render() {
        const p = this.props;
        const lookup = window.osa && window.osa.lookup && window.osa.lookup.serviceAddress;
        const searchAddressTitle = lookup && lookup.searchAddressTitle;
        const searchAddressTip = lookup && lookup.searchAddressTip;
        const legend = lookup && lookup.mapLegend;
        return (<div>
            <div className="form-group">
                <SectionHeader title={searchAddressTitle} />
                <label title={searchAddressTip}>
                    {searchAddressTip}
                </label>
                <div className="row">
                    <div className="col-md-9">
                        <input id="search-input" className="form-control" type="text" placeholder="Enter a location" autoComplete="off" />
                    </div>
                    {/* <div className="col-md-3 pull-right">
                        <FortisButton text="Search" onClick={this.onSearchClick} />
                    </div> */}
                </div>
                <div id="map" style={{ marginTop: "5px", height: "400px" }} />
                <p><i className="fa fa-minus color-leaflet-legend" />&nbsp; {legend}</p>
            </div>
        </div>
        );
    }
}


export default GoogleMap;

